export const ForgotPasswordTypes = {
  SEND_FORGOT_PASSWORD_CODE: 'SEND_FORGOT_PASSWORD_CODE',
  RENEW_ACCOUNT_PASSWORD: 'RENEW_ACCOUNT_PASSWORD',
  RESET_ALL_PASSWORD_STEPS: 'RESET_ALL_PASSWORD_STEPS',
  REPEAT_CODE: 'REPEAT_CODE',
}
